import * as yup from 'yup';

/** A feature flag's description, edited in the table: required, ignoring spaces. */
export const descriptionValidationSchema = yup.object({
	description: yup.string().trim().required('Description cannot be empty'),
});

/**
 * For the Description column's preProcessEditCellProps: sets the cell's error to the
 * validation message, which stops the grid saving it and is shown by
 * DataGridMultilinePopper.
 */
export const validateDescriptionCell = ({ props }) => {
	try {
		descriptionValidationSchema.validateSync({ description: props.value });
		return { ...props, error: false };
	} catch (error) {
		return { ...props, error: error.message };
	}
};
